export default "__VITE_ASSET__BX7s4WRA__"